'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPlaystation = function IoPlaystation(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.3 15.9c0 0.8 0 1.7-0.2 2.5-0.2 0.8-0.4 1.6-0.8 2.2-0.3 0.6-0.8 1-1.4 1.4-0.5 0.3-1.2 0.4-1.9 0.4-1 0-2.4-0.3-3.2-0.7v-10.4c0-0.7-0.6-1.3-1.2-1.3h-0.1c-0.7 0-1.3 0.6-1.3 1.3v23.7l-6.2-2v-28s2.2 0.3 5.9 1.4 5.2 1.6 6.5 2.4c0.6 0.4 1.2 0.9 1.7 1.4 0.5 0.5 1 1 1.3 1.8 0.6 1.2 0.8 2.5 0.9 3.9z m-24.5 12.1c-0.3 0.1-0.6 0.2-0.9 0.4 0 0.1-0.2 0.3-0.1 0.4s0.3 0.3 0.5 0.4c0.4 0.2 1 0.3 1.4 0.3 0.6 0 1.2 0 1.8-0.2 0.3-0.1 0.7-0.2 1-0.4 2.4-0.8 3.3-0.9 3.3-0.9v3.3c-1.1 0.1-2.9 0.3-4 0.3-2.3 0-4.6-0.3-6.8-1.1-0.7-0.2-1.5-0.4-2.1-0.9-0.4-0.2-0.7-0.6-0.8-1-0.2-0.3-0.1-0.7 0.1-1s0.3-0.6 0.7-0.9c0.7-0.5 1.4-0.8 2.2-1.1 0.6-0.3 1.3-0.5 2-0.8 2.7-0.9 8.7-2.8 8.7-2.8v3.6s-4.9 1.6-7 2.4z m33.2-1c0 0.4-0.2 0.7-0.4 1-0.5 0.6-1.1 0.9-1.7 1.2s-1.3 0.6-2 0.9c-4.3 1.5-13.4 4.6-13.4 4.6v-3.8s7.2-2.3 10.4-3.4c0.5-0.2 0.9-0.3 1.2-0.6 0.2-0.2 0.4-0.3 0.3-0.5-0.1-0.2-0.3-0.3-0.5-0.4-0.5-0.1-1-0.2-1.5-0.2-0.8 0-1.5 0.1-2.3 0.4-2.3 0.8-7.6 2.5-7.6 2.5v-3.9s3.5-1.1 5.2-1.2c0.7-0.1 1.8-0.1 2.5-0.1 2 0 4.2 0.2 6.1 0.9 0.4 0.1 0.7 0.2 1.1 0.4 0.7 0.2 1.4 0.6 2 1.1 0.3 0.3 0.6 0.7 0.6 1.1z' })
        )
    );
};

exports.default = IoPlaystation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/playstation.js
// module id = 2384
// module chunks = 0